import { ATSetupTabForm } from '@App/app/entities/forms/at-setup-tab-form.model';
import { PpSetupForm } from '@App/app/entities/forms/pp-setup-tab-form.model';
import { ProductionForm } from '@App/app/entities/forms/production-form.model';
import { PostProcessingSettings } from '@App/app/entities/processing/build-process-status.model';
import { BuildProcess } from '@App/app/entities/processing/build-process.model';
import { ProductionSettings } from '@App/app/entities/processing/production-settings.model';
import {
  startAerotriangulation,
  startPostProcessing,
  startProduction,
} from '@App/app/pages/processing/store/processes/actions/processes.actions';

export const buildProductionAction = (
  currentBuildProcess: BuildProcess,
  productionForm: ProductionForm['value'],
) => {
  const reconstructionSettings = { ...productionForm };
  delete reconstructionSettings.withObj;
  delete reconstructionSettings.withPointCloud;
  delete reconstructionSettings.withOrthoDSM;

  return startProduction({
    process: new BuildProcess({
      ...currentBuildProcess.toHttp(),
      productionSettings: reconstructionSettings as ProductionSettings,
      buildProcessTypeId: 2,
      buildProcessStatusId: 4,
      withObj: productionForm.withObj,
      withPointCloud: productionForm.withPointCloud,
      withOrthoDsm: productionForm.withOrthoDSM,
    }),
  });
};

export const buildAerotriangulationAction = (
  currentBuildProcess: BuildProcess,
  aerotriangulationSettings: ATSetupTabForm['value'],
) =>
  startAerotriangulation({
    process: new BuildProcess({
      ...currentBuildProcess.toHttp(),
      atSettings: aerotriangulationSettings,
      buildProcessTypeId: 1,
      buildProcessStatusId: 4,
      runAerotriangulationAutomatically: true,
    }),
  });

export const buildPostProcessingAction = (
  currentBuildProcess: BuildProcess,
  postProcessingSettings: PpSetupForm['value'],
) =>
  startPostProcessing({
    process: new BuildProcess({
      ...currentBuildProcess.toHttp(),
      postProcessingSettings: postProcessingSettings as PostProcessingSettings,
      buildProcessTypeId: 4,
      buildProcessStatusId: 4,
    }),
  });
